module.exports = __webpack_public_path__ + "img/aqua_xprn.fdf53c2.png";